export default __webpack_public_path__ + "static/media/gallery - potions_00.997c36a4.jpg";